<template>
    <div>
        <journey-connection-toggle
            :value="isDisabled"
            @input="$emit('update:is-disabled', $event)"

            :label="resource('Bool_Disabled')"
        />
        
        <journey-connection-deduplication-field
                :is-active="!isDisabled"
                :options="fieldNameOpts" 
                :value="fieldName" 
                @input="$emit('update:fieldName', $event)" 
        />
    </div>
</template>

<script>
    import api from "../../../api";
    import {bootstrapDangerGrowl as errorGrowl} from "../../../../../Util/growler";
    
    import resourceMixin from "../../../../../Util/Mixins/resources";

    import JourneyConnectionDeduplicationField from './DeduplicationSettings/JourneyConnectionDeduplicationField.vue';
    import JourneyConnectionToggle from "./JourneyConnectionToggle.vue";
    
    export default {
        name: 'journey-connection-deduplication-settings',
        mixins: [resourceMixin],
        components: {
            JourneyConnectionDeduplicationField,
            JourneyConnectionToggle
        },
        created() {
            const vm = this;
            
            //Ensure at the very least our current selection is displayed
            if(vm.fieldName){
                vm.fieldNameOpts = [vm.fieldName];
            }
            
            api.getTouchpointDeduplicationFields().then(
                opts => vm.fieldNameOpts = opts,
                err => errorGrowl(err)
            )
        },
        watch: {
            isDisabled(value){
                //Clear fieldName on disable
                if(value){
                    this.$emit('update:fieldName', null);
                }
            }
        },
        data: () => ({
            fieldNameOpts: []
        }),
        props: {
            isDisabled: Boolean,
            fieldName: String
        }
    }
</script>